export var ACTION;
(function (ACTION) {
    ACTION["GOTO_PHONE"] = "GOTO_PHONE";
    ACTION["DIGIO_ANDROID_CALLBACK"] = "DIGIO_ANDROID_CALLBACK";
    ACTION["CANCEL_DIGIO"] = "CANCEL_DIGIO";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["FAILED_VERIFICATION"] = "FAIILED_VERIFICATION";
    ACTION["HIDE_POPUP"] = "HIDE_POPUP";
    ACTION["NAVIGATE_HANDLE_ACTION"] = "NAVIGATE_HANDLE_ACTION";
})(ACTION || (ACTION = {}));
